'use strict'

/**
 * Project easytitle24 common
 * Created by hielo on 2019-03-14
 *
 * This plugin exposes common services through a Vue.js plugin
 */

import {jsonrpc} from 'Common/jsonrpc'
import {configService} from './config-service'
import {jnxStorage} from './storage-service'
import {projectFilesService} from './project-files-service'
import {security} from './security-service'
import { EventBus } from 'Common/event-bus'
import _ from 'lodash'
import {helpService} from './help-service'
import {productService} from './product-service'

function commonServices (Vue) {
	if (commonServices.installed) {
		return
	}
	if (typeof Vue.http !== 'undefined') {
		//
		// Exposing common services
		//
		Vue.prototype.$e24Common = {
			storageService: jnxStorage(),
			security: security(),
			helpService: helpService(Vue.http)
		}

		//
		// Adding jsonrpc and common services under e24Common
		//

		Vue.http.jsonrpc = jsonrpc(Vue.http, Vue.prototype.$Progress)

		// Interceptor
		Vue.http.interceptors.push((request, next) => {
			// Adding authorization header to jsonrpc requests
			if (!_.isNil(request.body) && !_.isNil(request.body.jsonrpc)) {
				if (!_.isNil(Vue.prototype.$e24Common.security.getSharedAuthHeader())) {
					request.headers.set('Authorization', Vue.prototype.$e24Common.security.getSharedAuthHeader())
				}
			}

			// Catch invalid token response
			next((response) => {
				if (response.status === 401 && response.bodyText === 'invalid token...') {
					console.log('Broadcasting invalid token')
					EventBus.$emit('jsonrpc', 'INVALID_TOKEN')
				}
			})
		})
		// Vue.prototype.security = {
		// 	security: security()
		// }

		Vue.e24Common = {
			configService: configService(Vue),
			prjFilesService: projectFilesService(Vue),
			productService: productService(Vue.http)
		}
	} else {
		console.error('To install the jsonrpc plugin it is necessary to have vue-resource in advance')
	}
}

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(commonServices)
}

export default commonServices



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/services/index.js